export default "__VITE_ASSET__VAZ4OQge__"